import { ExternalLink } from "lucide-react";
import { Button } from "@codelittinc/carbon-design-system";
import { trackApp, type AppEvents } from "../lib/analytics";

interface TicketLinkProps {
  href: string;
  variant?: "default" | "outline" | "link";
  className?: string;
  /** Where it was clicked, counted as `it_ticket_clicked`; none where PostHog never starts. */
  via?: AppEvents["it_ticket_clicked"]["via"];
  /** The tool whose card it is on. */
  toolKey?: string;
}

/** "Raise a ticket with IT", opening the helpdesk form in a new tab. */
export function TicketLink({ href, variant = "link", className, via, toolKey }: TicketLinkProps) {
  return (
    <Button
      asChild
      variant={variant}
      {...(variant === "link" ? {} : { size: "lg" as const })}
      className={className}
    >
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        {...(via ? { onClick: () => trackApp("it_ticket_clicked", { via, ...(toolKey ? { tool_key: toolKey } : {}) }) } : {})}
      >
        Raise a ticket with IT
        <ExternalLink className="size-4" aria-hidden />
      </a>
    </Button>
  );
}
